export interface HelpEntry {
  title: string;
  description: string;
  docUrl?: string;
}

const helpTexts: Record<string, HelpEntry> = {
  // === Header ===
  'header-school-selector': {
    title: 'Выбор школы',
    description:
      'Нажмите, чтобы переключиться между школами, к которым у вас есть доступ. Текущая школа отображается в заголовке.',
  },
  'header-instruction': {
    title: 'Инструкция',
    description:
      'Переход на портал документации SCAN Analytics с подробными руководствами по всем функциям.',
    docUrl: 'https://help.scananalytics.ru/',
  },
  'header-support': {
    title: 'Поддержка',
    description: 'Открывает чат с технической поддержкой SCAN Analytics в Telegram.',
  },
  'header-billing': {
    title: 'Биллинг',
    description:
      'Информация о текущем тарифе, дате окончания доступа и оплате. Управление подпиской и реквизитами.',
  },
  'header-license': {
    title: 'Информация о лицензии',
    description:
      'Показывает дату окончания доступа и количество оставшихся дней. Нажмите для перехода в раздел биллинга.',
  },
  'header-user-menu': {
    title: 'Меню пользователя',
    description: 'Открывает меню с доступом к профилю и выходом из системы.',
  },
  'header-crm': {
    title: 'CRM',
    description:
      'Панель администратора для управления школами, пользователями, заказами, платежами и тарифами.',
  },

  // === Навигация ===
  'nav-overview': {
    title: 'Сводка',
    description:
      'Главный дашборд с ключевыми показателями школы. Отображает дашборд, добавленный в сводку. Настраивается в разделе "Дашборды".',
  },
  'nav-dashboards': {
    title: 'Дашборды',
    description:
      'Интерактивные панели с графиками и таблицами. Создавайте свои дашборды, настраивайте блоки, перетаскивайте и изменяйте размер.',
  },
  'nav-reports': {
    title: 'Отчёты',
    description:
      'Детальные отчёты по регистрациям, заказам, платежам, вебинарам и рекламе. Поддерживают фильтры, группировки, метрики и сохранение.',
  },
  'nav-ads': {
    title: 'Реклама',
    description:
      'Управление рекламными кабинетами и объявлениями. Автоматическое и ручное размещение, оптимизатор бюджета.',
  },
  'nav-bd': {
    title: 'Данные',
    description:
      'Просмотр и управление данными: пользователи платформы, вебинары, посещения, импорт и экспорт данных.',
  },
  'nav-tools': {
    title: 'Инструменты',
    description:
      'Дополнительные инструменты: интеграция с Яндекс.Метрикой (конверсии) и Telegram-радар для отправки отчётов.',
  },
  'nav-settings': {
    title: 'Настройка',
    description:
      'Настройки школы: интеграции (GetCourse, рекл. кабинеты, Яндекс.Метрика, Бизон 365), скрипты отслеживания, воронки продаж, сотрудники.',
  },
  'nav-suppliers': {
    title: 'Партнёрка',
    description:
      'Партнёрская программа SCAN Analytics. Приглашайте пользователей по реферальной ссылке и получайте бонусы.',
  },

  // === Параметры отчёта ===
  'params-period': {
    title: 'Период отчёта',
    description:
      'Выберите временной диапазон для данных отчёта. Доступны предустановки (сегодня, вчера, неделя, месяц) и произвольный выбор дат.',
  },
  'params-attribution': {
    title: 'Атрибуция',
    description:
      'Определяет, какому источнику трафика присваивается конверсия. Выберите модель атрибуции: по первому или последнему касанию.',
  },
  'params-type_applications': {
    title: 'Тип регистрации',
    description:
      'Выберите тип регистрации для фильтрации данных в отчёте.',
  },
  'params-details': {
    title: 'Детализация',
    description:
      'Настройка уровня детализации отчёта. Позволяет выбрать, какие дополнительные данные включить в отчёт.',
  },
  'params-filters': {
    title: 'Фильтры',
    description:
      'Ограничивают выборку данных по условиям. Например: только определённые UTM-метки, продукты, статусы заказов или источники трафика.',
  },
  'params-funnel': {
    title: 'Воронка продаж',
    description:
      'Выберите воронку продаж для применения фильтров. Воронка — набор условий для анализа конверсий.',
  },
  'params-segment': {
    title: 'Сегмент',
    description:
      'Сегмент — сохранённый набор фильтров. Выберите сегмент для быстрого применения заранее настроенных условий фильтрации.',
  },
  'params-compare': {
    title: 'Сравнение периодов',
    description:
      'Режим сравнения двух периодов. Позволяет увидеть динамику показателей: текущий период vs выбранный для сравнения.',
  },
  'params-refresh': {
    title: 'Обновить данные',
    description: 'Перезагрузить данные отчёта с сервера с текущими параметрами.',
  },
  'params-request': {
    title: 'Показать данные',
    description:
      'Запросить данные отчёта с выбранными параметрами (период, группировки, метрики, фильтры).',
  },

  // === Группировки и метрики ===
  'report-groupings': {
    title: 'Группировки',
    description:
      'Определяют, как данные разбиваются по строкам таблицы. Например: по дням, по UTM-меткам, по продуктам, по менеджерам.',
  },
  'report-metrics': {
    title: 'Метрики',
    description:
      'Числовые показатели в колонках таблицы: количество регистраций, заказов, платежей, суммы, конверсии и другие.',
  },

  // === Заголовок отчёта ===
  'report-title': {
    title: 'Название отчёта',
    description:
      'Название текущего отчёта. Нажмите для редактирования при сохранении.',
  },
  'report-save': {
    title: 'Сохранить отчёт',
    description:
      'Сохраняет текущие настройки отчёта (период, группировки, метрики, фильтры) для быстрого доступа. Горячая клавиша: Ctrl+S / Cmd+S.',
  },
  'report-save-as': {
    title: 'Сохранить как новый',
    description:
      'Создаёт копию текущего отчёта с новым названием. Исходный отчёт остаётся без изменений.',
  },
  'report-export': {
    title: 'Экспорт в Excel',
    description:
      'Выгружает данные текущего отчёта в формате XLSX. Экспортируются все данные с учётом текущих фильтров.',
  },
  'report-compare': {
    title: 'Сравнить периоды',
    description:
      'Включает режим сравнения двух периодов. Данные отображаются в двух колонках с процентом изменения.',
  },
  'report-fullscreen': {
    title: 'Полноэкранный режим',
    description:
      'Разворачивает отчёт на весь экран, скрывая навигацию и заголовок для максимального пространства.',
  },
  'report-menu': {
    title: 'Меню отчёта',
    description:
      'Дополнительные действия: сохранить, удалить, изменить доступ, добавить теги.',
  },

  // === График ===
  'report-chart': {
    title: 'График отчёта',
    description:
      'Визуальное представление данных отчёта. Поддерживает несколько типов: линейный, столбчатый, круговой, с областями и другие.',
  },
  'chart-type-line': {
    title: 'Линейный график',
    description: 'Отображает данные в виде линий. Удобен для показа динамики во времени.',
  },
  'chart-type-bar': {
    title: 'Столбчатая диаграмма',
    description: 'Отображает данные в виде вертикальных или горизонтальных столбцов. Удобна для сравнения значений.',
  },
  'chart-type-pie': {
    title: 'Круговая диаграмма',
    description: 'Отображает долю каждой категории в общем объёме. Удобна для анализа структуры.',
  },
  'chart-type-area': {
    title: 'График с областями',
    description: 'Аналогичен линейному, но с заполненной областью под линией. Подчёркивает объём данных.',
  },
  'chart-type-funnel': {
    title: 'Воронка',
    description: 'Отображает этапы конверсии в виде сужающейся воронки. Показывает потери на каждом этапе.',
  },
  'chart-type-gauge': {
    title: 'Спидометр',
    description: 'Отображает одно значение относительно целевого. Удобен для KPI и целевых показателей.',
  },

  // === Таблица отчёта ===
  'report-table': {
    title: 'Таблица отчёта',
    description:
      'Основная таблица с данными. Поддерживает сортировку по колонкам (клик на заголовок), фильтрацию, закрепление столбцов и процентные значения.',
  },

  // === Дашборды ===
  'dashboard-add-block': {
    title: 'Добавить блок',
    description:
      'Добавляет новый блок на дашборд. Можно выбрать тип: график, таблица, числовой показатель.',
  },
  'dashboard-settings': {
    title: 'Настройки дашборда',
    description:
      'Управление дашбордом: переименование, автообновление, копирование, удаление и настройка доступа.',
  },
  'dashboard-fullscreen': {
    title: 'Полноэкранный режим',
    description: 'Разворачивает дашборд на весь экран, скрывая навигацию и заголовок.',
  },
  'dashboard-save': {
    title: 'Сохранить дашборд',
    description: 'Сохраняет текущее расположение и настройки всех блоков дашборда.',
  },
  'dashboard-grid': {
    title: 'Сетка блоков',
    description:
      'Блоки можно перетаскивать мышью и изменять их размер за правый нижний угол. Расположение сохраняется автоматически.',
  },
  'dashboard-period': {
    title: 'Период дашборда',
    description:
      'Общий период для всех блоков дашборда. Можно переопределить для отдельных блоков в их настройках.',
  },
  'dashboard-auto-refresh': {
    title: 'Автообновление',
    description:
      'Автоматическое обновление данных дашборда через заданный интервал. Настраивается в настройках дашборда.',
  },

  // === Настройки ===
  'settings-integrations': {
    title: 'Интеграции',
    description:
      'Подключение внешних сервисов: GetCourse, рекламные кабинеты, Яндекс.Метрика, Бизон 365.',
  },
  'settings-school-info': {
    title: 'Информация о школе',
    description: 'Основные данные школы: название, домен, контактная информация.',
  },
  'settings-funnels': {
    title: 'Воронки продаж',
    description:
      'Настройка воронок для отслеживания конверсий от первого касания до покупки.',
    docUrl: 'https://help.scananalytics.ru/voronki-prodazh/',
  },
  'settings-tracking': {
    title: 'Скрипт отслеживания',
    description:
      'Скрипт для установки на сайт школы. Отслеживает посещения, источники трафика и действия пользователей.',
  },
  'settings-utm-script': {
    title: 'Скрипт захвата UTM',
    description:
      'Скрипт для захвата UTM-меток из URL и вставки в дополнительные поля нулевого заказа GetCourse.',
    docUrl:
      'https://help.scananalytics.ru/skript-vstavki-utm-metok-iz-url-v-dop-polya-nulevogo-zakaza-gc/',
  },
  'settings-employees': {
    title: 'Сотрудники',
    description:
      'Управление сотрудниками школы: добавление, удаление, назначение ролей и прав доступа.',
  },
  'settings-staff-add': {
    title: 'Добавить сотрудника',
    description: 'Создание нового сотрудника с назначением роли и прав доступа к разделам системы.',
  },
  'settings-track-validate': {
    title: 'Валидация электронной почты',
    description: 'Включает проверку корректности email-адресов при регистрации. Помогает фильтровать некорректные данные.',
  },
  'settings-track-utm': {
    title: 'Перекидывание UTM-меток',
    description: 'Автоматически переносит UTM-метки из URL на все страницы сайта. Обеспечивает корректное отслеживание источников трафика.',
  },
  'settings-track-script': {
    title: 'Скрипт отслеживания',
    description: 'Код для установки на страницу настроек GetCourse. Скопируйте и вставьте скрипт для начала отслеживания данных.',
    docUrl: 'https://help.scananalytics.ru/skript-otclezhivaniya-scan/',
  },
  'load-data-users': {
    title: 'Загрузить пользователей GC',
    description: 'Загрузка списка пользователей из GetCourse в систему аналитики.',
    docUrl: 'https://help.scananalytics.ru/ruchnaya-zagruzka-dannyh-po-shkole/',
  },
  'load-data-orders': {
    title: 'Загрузить заказы GC',
    description: 'Загрузка заказов и нулевых заказов из GetCourse.',
    docUrl: 'https://help.scananalytics.ru/ruchnaya-zagruzka-dannyh-po-shkole/',
  },
  'load-data-payments': {
    title: 'Загрузить платежи GC',
    description: 'Загрузка платежей из GetCourse.',
    docUrl: 'https://help.scananalytics.ru/ruchnaya-zagruzka-dannyh-po-shkole/',
  },
  'load-data-regs': {
    title: 'Загрузить регистрации',
    description: 'Загрузка данных о регистрациях.',
    docUrl: 'https://help.scananalytics.ru/ruchnaya-zagruzka-dannyh-po-shkole/',
  },
  'load-data-facebook': {
    title: 'Загрузить расходы по Facebook',
    description: 'Загрузка данных о рекламных расходах Facebook.',
    docUrl: 'https://help.scananalytics.ru/ruchnaya-zagruzka-dannyh-po-shkole/',
  },
  'load-data-manual': {
    title: 'Загрузить ручные расходы',
    description: 'Загрузка ручных рекламных расходов через файл.',
    docUrl: 'https://help.scananalytics.ru/ruchnaya-zagruzka-dannyh-po-shkole/',
  },

  // === Реклама ===
  'ads-cabinets': {
    title: 'Рекламные кабинеты',
    description:
      'Список подключённых рекламных кабинетов. Автоматическое и ручное размещение данных о расходах.',
  },
  'ads-announcements': {
    title: 'Объявления',
    description:
      'Список рекламных объявлений из подключённых кабинетов. Просмотр статистики по каждому объявлению.',
  },
  'ads-budget-optimizer': {
    title: 'Оптимизатор бюджета',
    description:
      'Автоматические правила для управления рекламным бюджетом. Настройте условия и действия для автоматизации.',
  },
  'ads-add-spend': {
    title: 'Добавить расход',
    description: 'Ручное добавление расхода на рекламу для учёта в аналитике.',
  },
  'ads-create-cabinet': {
    title: 'Создать рекламный кабинет',
    description: 'Создание нового рекламного кабинета для ручного размещения. Позволяет вести учёт расходов по рекламным источникам.',
  },
  'ads-rules-title': {
    title: 'Оптимизатор рекламного бюджета',
    description: 'Автоматическое управление рекламными кампаниями по заданным правилам. Система проверяет метрики и выполняет действия: изменение бюджета, отключение кампаний, уведомления в Telegram.',
    docUrl: 'https://help.scananalytics.ru/avtomaticheskoe-upravlenie-reklamoy/',
  },
  'ads-rules-add': {
    title: 'Добавить правило',
    description: 'Создание нового правила автоматического управления рекламой. Задайте условия, действия и частоту проверки.',
  },
  'ads-how-to': {
    title: 'Как настроить рекламу?',
    description:
      'Пошаговая инструкция по настройке рекламных кабинетов и интеграции с платформами.',
    docUrl:
      'https://help.scananalytics.ru/nastroyka-reklamy-dlya-skvoznoy-analitiki/',
  },

  // === Данные ===
  'data-platform': {
    title: 'Платформа',
    description:
      'Данные из подключённой платформы (GetCourse): пользователи, регистрации, заказы, платежи.',
  },
  'data-webinars': {
    title: 'Вебинары',
    description:
      'Список вебинаров и их статистика: участники, длительность, комментарии, качество.',
  },
  'data-visits': {
    title: 'Посещения',
    description:
      'Данные о посещениях сайта: сессии, хиты, посетители, статистика по экранам.',
  },
  'data-import': {
    title: 'Импорт данных',
    description: 'Загрузка данных из внешних источников в систему аналитики.',
  },
  'data-export': {
    title: 'Экспорт данных',
    description:
      'Выгрузка данных из системы. Создание задач на экспорт с выбором параметров и формата.',
  },
  'data-manual-upload': {
    title: 'Ручная загрузка данных',
    description: 'Загрузка данных вручную из файлов (CSV, Excel) в систему аналитики.',
  },

  // === Биллинг ===
  'billing-page': {
    title: 'Биллинг',
    description: 'Управление подпиской и финансами: баланс, тарифы, счета, акты, пополнения и реквизиты для юридических лиц.',
  },
  'billing-balance': {
    title: 'Баланс и тариф',
    description:
      'Текущий баланс, информация о тарифе и продление доступа к сервису.',
  },
  'billing-bills': {
    title: 'Счета и акты',
    description: 'Список выставленных счетов и актов. Скачивание документов в PDF.',
  },
  'billing-withdraws': {
    title: 'Пополнения и списания',
    description: 'История всех финансовых операций: пополнения баланса и списания за услуги.',
  },
  'billing-requisites': {
    title: 'Реквизиты',
    description:
      'Юридические реквизиты для выставления счетов. Добавление и редактирование организаций.',
  },

  // === Профиль ===
  'profile-contacts': {
    title: 'Контактные данные',
    description: 'Имя, телефон и email пользователя. Нажмите для редактирования.',
  },
  'profile-password': {
    title: 'Смена пароля',
    description:
      'Изменение пароля учётной записи. Введите текущий и новый пароль.',
  },
  'profile-telegram': {
    title: 'Привязка Telegram',
    description:
      'Подключение Telegram-бота для получения уведомлений и отчётов. Необходимо для работы Telegram-радара.',
  },

  // === Партнёрка ===
  'partner-page': {
    title: 'Партнёрский кабинет',
    description: '2-х уровневая партнёрская программа SCAN Analytics. Общая информация, рефералы, начисления, выплаты и рекламные креативы.',
  },
  'partner-info': {
    title: 'Партнёрская программа',
    description:
      'Информация о партнёрской программе: условия, реферальная ссылка, статистика.',
  },
  'partner-referrals': {
    title: 'Рефералы',
    description: 'Список привлечённых пользователей по вашей реферальной ссылке.',
  },
  'partner-payments': {
    title: 'Платежи партнёров',
    description: 'История выплат по партнёрской программе.',
  },
  'partner-accruals': {
    title: 'Начисления',
    description: 'История начислений за привлечённых пользователей.',
  },

  // === Инструменты ===
  'tools-yandex-metrics': {
    title: 'Яндекс.Метрика (конверсии)',
    description:
      'Интеграция с Яндекс.Метрикой для импорта данных о конверсиях и целях.',
  },
  'tools-telegram-radar': {
    title: 'Telegram-радар',
    description:
      'Автоматическая отправка отчётов в Telegram в заданное время. Настройте расписание и получайте данные прямо в мессенджер.',
    docUrl:
      'https://doc.scananalytics.ru/instrumenty/telegram-radar/',
  },

  // === Правила рекламы (оптимизатор) ===
  'rule-name': {
    title: 'Название правила',
    description: 'Уникальное название для идентификации правила в списке.',
  },
  'rule-source': {
    title: 'Источник рекламы',
    description:
      'Выберите рекламную платформу: Yandex Direct, Facebook, VK, myTarget и другие.',
  },
  'rule-conditions': {
    title: 'Условия срабатывания',
    description:
      'Задайте метрику, оператор сравнения и пороговое значение. Можно создавать группы условий с логикой И/ИЛИ.',
  },
  'rule-frequency': {
    title: 'Частота проверки',
    description:
      'Как часто система будет проверять условия правила (в днях).',
  },
  'rule-actions': {
    title: 'Действия',
    description:
      'Что произойдёт при срабатывании правила: изменение бюджета, уведомление в Telegram.',
  },

  // === Дополнительные элементы ===
  'settings-track-copy': {
    title: 'Скопировать скрипт',
    description: 'Копирует скрипт отслеживания в буфер обмена для вставки в GetCourse.',
  },
  'settings-track-add-domain': {
    title: 'Добавить домен',
    description: 'Добавление нового домена для междоменного отслеживания.',
  },
  'settings-school-edit': {
    title: 'Редактировать школу',
    description: 'Изменение настроек подключённой школы.',
  },
  'settings-school-delete': {
    title: 'Удалить школу',
    description: 'Удаление подключённой школы из системы.',
  },
  'settings-staff-help': {
    title: 'Помощь по сотрудникам',
    description: 'Открывает инструкцию по работе с разделом сотрудников.',
    docUrl: 'https://help.scananalytics.ru/sotrudniki/',
  },
  'ads-import-excel': {
    title: 'Загрузить объявление',
    description: 'Массовая загрузка объявлений из файла Excel.',
    docUrl: 'https://help.scananalytics.ru/massovaya-zagruzka-obyavleniy-ruchnogo-razmescheniya/',
  },
  'ads-rules-help': {
    title: 'Как настроить управление рекламой',
    description: 'Открывает инструкцию по настройке автоматического управления рекламой.',
    docUrl: 'https://help.scananalytics.ru/avtomaticheskoe-upravlenie-reklamoy/',
  },
  'report-help': {
    title: 'Как работать с отчётом',
    description: 'Открывает инструкцию по работе с данным типом отчёта.',
  },
  'dashboard-zoom-out': {
    title: 'Уменьшить масштаб',
    description: 'Уменьшение масштаба дашборда. Также доступно через Ctrl + колёсико мыши.',
  },
  'dashboard-zoom-in': {
    title: 'Увеличить масштаб',
    description: 'Увеличение масштаба дашборда. Также доступно через Ctrl + колёсико мыши.',
  },
  'dashboard-zoom-reset': {
    title: 'Сбросить масштаб',
    description: 'Возвращает масштаб дашборда к значению 100%.',
  },
  'partner-creatives': {
    title: 'Рекламные креативы',
    description: 'Раздел рекламных креативов для партнёрской программы.',
  },

  // === График — дополнительные элементы ===
  'chart-toggle': {
    title: 'Показать/скрыть график',
    description: 'Переключает видимость графика в отчёте. При скрытии остаётся только таблица данных.',
  },
  'chart-type-bubble': {
    title: 'Пузырьковая диаграмма',
    description: 'Отображает данные в виде кругов разного размера. Размер пузырька пропорционален значению метрики.',
  },
  'chart-type-treemap': {
    title: 'Древовидная карта',
    description: 'Отображает иерархические данные в виде вложенных прямоугольников. Площадь блока пропорциональна значению.',
  },
  'chart-help': {
    title: 'Справка по графикам',
    description: 'Подробное описание доступных типов графиков и их особенностей.',
  },
  'chart-trend': {
    title: 'Линия тренда',
    description: 'Добавляет линию тренда на график. Доступные типы: линейный, средняя, скользящее среднее (MA). Работает для линейного графика и графика с областями.',
  },
  'chart-axis-y': {
    title: 'Ось Y',
    description: 'Показать или скрыть ось Y на графике. Ось Y отображает шкалу значений метрик.',
  },

  // === Модальные окна — метрики ===
  'modal-metrics-open': {
    title: 'Выбор метрик',
    description: 'Открывает окно выбора метрик для отчёта. Метрики — числовые показатели, отображаемые в колонках таблицы.',
  },
  'modal-groupings-open': {
    title: 'Выбор группировок',
    description: 'Открывает окно выбора группировок для отчёта. Группировки определяют, как данные разбиваются по строкам.',
  },
  'modal-create-metric': {
    title: 'Создать метрику',
    description: 'Создание пользовательской метрики. Можно добавить фильтр к существующей метрике или задать формулу расчёта.',
  },
  'modal-clear-selection': {
    title: 'Очистить выбор',
    description: 'Снимает выделение со всех выбранных элементов в текущем окне.',
  },
  'metric-how-to-create': {
    title: 'Как создать метрику?',
    description: 'Открывает инструкцию по созданию пользовательских метрик.',
    docUrl: 'https://help.scananalytics.ru/',
  },
  'metric-save': {
    title: 'Сохранить метрику',
    description: 'Сохраняет новую пользовательскую метрику с заданными параметрами.',
  },
  'metric-type-filter': {
    title: 'Метрика с фильтром',
    description: 'Создаёт метрику на основе существующей с добавлением условий фильтрации. Например: «Заказы, где продукт = Курс А».',
  },
  'metric-type-formula': {
    title: 'Расчётная метрика',
    description: 'Создаёт метрику по формуле из существующих метрик. Поддерживает операции: сложение, вычитание, умножение, деление.',
  },
  'metric-add-condition': {
    title: 'Добавить условие заливки',
    description: 'Добавляет условие цветовой заливки ячеек в таблице на основе значений метрики.',
  },
  'metric-edit-save': {
    title: 'Сохранить изменения метрики',
    description: 'Сохраняет изменения в существующей пользовательской метрике.',
  },
  'metric-edit-delete': {
    title: 'Удалить метрику',
    description: 'Удаляет пользовательскую метрику. Это действие нельзя отменить.',
  },

  // === Модальные окна — полный отчёт ===
  'full-report-open': {
    title: 'Открыть в отчёте',
    description: 'Переходит к полному отчёту с текущими настройками блока дашборда.',
  },
  'full-report-new-tab': {
    title: 'Открыть в новой вкладке',
    description: 'Открывает полный отчёт в новой вкладке браузера.',
  },
  'full-report-close': {
    title: 'Закрыть',
    description: 'Закрывает окно предпросмотра блока дашборда.',
  },

  // === Модальные окна — блоки дашборда ===
  'block-groupings': {
    title: 'Группировки блока',
    description: 'Выбор группировок для блока дашборда. Определяет, по каким параметрам разбиваются данные.',
  },
  'block-metrics': {
    title: 'Метрики блока',
    description: 'Выбор метрик для блока дашборда. Определяет, какие числовые показатели отображаются.',
  },
  'block-preview': {
    title: 'Предпросмотр блока',
    description: 'Показывает предварительный вид блока с текущими настройками.',
  },
  'block-save': {
    title: 'Сохранить блок',
    description: 'Сохраняет новый блок дашборда с выбранными группировками и метриками.',
  },
  'block-close': {
    title: 'Закрыть',
    description: 'Закрывает окно добавления блока без сохранения.',
  },
  'block-edit-groupings': {
    title: 'Группировки блока (редакт.)',
    description: 'Изменение группировок существующего блока дашборда.',
  },
  'block-edit-metrics': {
    title: 'Метрики блока (редакт.)',
    description: 'Изменение метрик существующего блока дашборда.',
  },
  'block-edit-preview': {
    title: 'Предпросмотр (редакт.)',
    description: 'Предпросмотр блока после внесённых изменений.',
  },
  'block-edit-save': {
    title: 'Сохранить изменения блока',
    description: 'Сохраняет изменения в существующем блоке дашборда.',
  },
  'block-edit-close': {
    title: 'Закрыть (редакт.)',
    description: 'Закрывает окно редактирования блока без сохранения.',
  },
  'monitor-start': {
    title: 'Запустить мониторинг',
    description: 'Запускает автообновление дашборда с заданным интервалом. Данные будут обновляться автоматически.',
  },

  // === Модальные окна — настройки ===
  'staff-add-submit': {
    title: 'Добавить сотрудника',
    description: 'Подтверждает создание нового сотрудника с выбранной ролью и правами доступа.',
  },
  'staff-edit-submit': {
    title: 'Сохранить сотрудника',
    description: 'Сохраняет изменения в профиле сотрудника.',
  },
  'tg-create': {
    title: 'Создать отчёт TG',
    description: 'Создаёт новую задачу на автоматическую отправку отчёта в Telegram.',
  },
  'tg-cancel': {
    title: 'Отмена',
    description: 'Закрывает окно создания Telegram-отчёта без сохранения.',
  },
  'tg-update': {
    title: 'Обновить отчёт TG',
    description: 'Сохраняет изменения в настройках Telegram-отчёта.',
  },
  'tg-delete': {
    title: 'Удалить отчёт TG',
    description: 'Удаляет задачу отправки отчёта в Telegram.',
  },
  'requisites-save': {
    title: 'Сохранить реквизиты',
    description: 'Сохраняет юридические реквизиты организации для выставления счетов.',
  },
  'ads-connect-submit': {
    title: 'Подключить рекл. кабинет',
    description: 'Подтверждает подключение рекламного кабинета к системе аналитики.',
  },
  'access-all-schools': {
    title: 'Доступ для всех школ',
    description: 'Открывает доступ к отчёту для всех школ аккаунта.',
  },
  'access-all-staff': {
    title: 'Доступ для всех сотрудников',
    description: 'Открывает доступ к отчёту для всех сотрудников текущей школы.',
  },
  'access-only-me': {
    title: 'Только для меня',
    description: 'Ограничивает доступ к отчёту — только для вашей учётной записи.',
  },
  'school-add': {
    title: 'Добавить школу',
    description: 'Подключение новой школы к системе аналитики. Потребуется указать данные для интеграции.',
  },
};

export const getHelpText = (helpId: string): HelpEntry | null => {
  return helpTexts[helpId] || null;
};

export default helpTexts;
